import { render, staticRenderFns } from "./BidRecord.vue?vue&type=template&id=fafa8fce&scoped=true&"
import script from "./BidRecord.vue?vue&type=script&lang=js&"
export * from "./BidRecord.vue?vue&type=script&lang=js&"
import style0 from "./BidRecord.vue?vue&type=style&index=0&id=fafa8fce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafa8fce",
  null
  
)

export default component.exports